import { Routes, Route, useOutletContext } from "react-router-dom";
import { Home } from "../Pages/Private/Manifestation/Home";
import { Event } from "../Pages/Private/Manifestation/Event/Event";
import { EspaceList } from "../Pages/Private/Manifestation/Espace/EspaceList";
import { Participation } from "../Pages/Private/Manifestation/Participation";
import { EditeurNewsletterVersailles } from "../Pages/Private/Manifestation/Manifestation/Campagnes";

export const ManifestationsRouter = () => {
    const [user, setUser] = useOutletContext();

    return (
        <Routes>
            <Route path="/manifestations" element={<Home />} />

            <Route path="/participations" element={<Participation />} />
            <Route path="/campagnes" element={<EditeurNewsletterVersailles />} />

            <Route
                path="/manifestations/event/:id/:status"
                element={<Event />}
            />



        </Routes>
    );
};
